import { render, staticRenderFns } from "./pesananpascabayarfrm.vue?vue&type=template&id=084b8f20"
import script from "./pesananpascabayarfrm.vue?vue&type=script&lang=js"
export * from "./pesananpascabayarfrm.vue?vue&type=script&lang=js"
import style0 from "./pesananpascabayarfrm.vue?vue&type=style&index=0&id=084b8f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports